import { cn } from '@/lib/utils'
import { ReactNode } from 'react'

interface CustomScrollAreaProps {
	children: ReactNode
	className?: string
}

/**
 * Custom scroll area component for VisitorContextSidebar
 * Built to avoid Radix UI ScrollArea's display: table issue
 */
export function CustomScrollArea({
	children,
	className,
}: CustomScrollAreaProps) {
	return (
		<div
			className={cn(
				'overflow-y-auto overflow-x-hidden',
				className
			)}
			style={{
				scrollbarWidth: 'thin',
				scrollbarColor: 'hsl(var(--border)) transparent',
			}}>
			{children}
		</div>
	)
}
